var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.93263 0 0 4.93263 0 11C0 17.0674 4.93263 22 11 22C17.0674 22 22 17.0674 22 11C22 4.93263 17.0674 0 11 0ZM11 6.29895C12.899 6.29895 14.4506 7.85053 14.4506 9.74951C14.4506 11.6485 12.899 13.2001 11 13.2001C9.10101 13.2001 7.54943 11.6485 7.54943 9.74951C7.54943 7.85053 9.10101 6.29895 11 6.29895ZM4.97895 17.6695V17.16C4.97895 15.701 6.15996 14.4969 7.64202 14.4969H14.3578C15.8168 14.4969 17.0209 15.6779 17.0209 17.16V17.6695C15.423 19.1052 13.3155 19.9853 10.9998 19.9853C8.68438 19.9853 6.57709 19.1052 4.9792 17.6695H4.97895Z",
    fill: "#3C2166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.aba6044b08712433a6e3581559664c37.svg";
export { ForwardRef as ReactComponent };